import Premiere from '@/components/schedule/Premiere';
import Livestream from '@/components/schedule/Livestream';
export default {
  components: {
    Premiere,
    Livestream
  },
  data() {
    return {
      showStreams: true,
      streamList: 0,
      liveCount: 0,
      premiereCount: 0,
      checkedLive: false,
      checkedPremiere: false
    };
  },
  props: {
    channel: {
      type: Number,
      default: 0
    },
    limit: {
      type: Number,
      default: 0
    },
    showNoResults: {
      type: Boolean,
      default: false
    },
    showloading: {
      type: Boolean,
      default: false
    }
  },
  mounted: function () {
    this.streamList = 'live';
  },
  methods: {
    setCount(count, type) {
      if (type === 0) {
        this.liveCount = count;
        if (count === 0) {
          this.streamList = 'premiere';
        }
        this.checkedLive = true;
      } else if (type === 1) {
        this.premiereCount = count;
        this.checkedPremiere = true;
      }
    }
  }
};